import { connect } from 'react-redux';
import {
    FrameworkActionCreator, ICustomerState,
    CustomerActionCreator, AppointmentActionCreator, IAppointmentState, ISpecsState,
} from 'src/store/states';
import CustSearch from 'src/components/CustSearch/CustSearch';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: ICustomerState & IAppointmentState & IStoreState & ISpecsState) => ({
    custInfo: state.Customer!['Customer'],
    errMsg: state.Customer!.errMsg,
    retCode: state.Customer!.retCode,
    specProfile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    fordSmarttFlag: state.Specs.specs!.fordSmarttFlag,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    toyLexLoginSent: state.Framework.toyLexLoginSent,
    mbzTrackingFlag: state.Specs.specs?.mbzTrackingFlag ?? '',
    toyotaTrackingFlag: state.Specs.specs?.toyotaTrackingFlag ?? '',
    lexusTrackingFlag: state.Specs.specs?.lexusTrackingFlag ?? '',
    mazdaCATrackingFlag: state.Specs.specs?.mazdaCATrackingFlag ?? '',
    kiaTrackingFlag: state.Specs.specs?.kiaTrackingFlag ?? '',
    sessionGUID: state.Framework.sessionId ?? '',
    multipleCustomers: state.Customer.multipleCustomers ?? false,
    svcContact: {num: state.Specs.specs?.svcSpecs?.contactPhnNum, ext: state.Specs.specs?.svcSpecs?.contactExt},
    bdyContact: {num: state.Specs.specs?.bdySpecs?.contactPhnNum, ext: state.Specs.specs?.bdySpecs?.contactExt},
    ossContact: {num: state.Specs.specs?.ossSpecs?.contactPhnNum, ext: state.Specs.specs?.ossSpecs?.contactExt},
    isCookiesEnabled: state.Framework.isCookiesEnabled,
    isMobile: state.Framework.desktopOrMobile === 'M',
    oemCustSearchLaunched: state.Framework.toyotaCustSearchLaunched === 'Y' || state.Framework.lexusCustSearchLaunched === 'Y' ||
        state.Framework.lexusTDCSLaunched === 'Y' || state.Framework.toyotaTDCSLaunched === 'Y',
    loading: state.Customer.loading,
    gmRewardsEligible: state.Specs.specs?.gmDealerCanRedeem,
    gmMemberErr: state.Customer.gmMemberErr,
    myGMRewardsLaunched: state.Specs.specs?.myGMRewardsLaunched,
    theme: state.Framework.theme,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    desktopOrMobile: state.Framework.desktopOrMobile,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    showGuestApptOption: state.Specs.specs?.showGuestAppt,
    vwTrackingFlag: state.Specs.specs?.vwTrackingFlag ?? '',
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    pushToLeftPane: FrameworkActionCreator.pushToLeftPane,
    customerSearch: CustomerActionCreator.CustomerSearch,
    spmCustomerCentral: CustomerActionCreator.OEMCustomerSearch,
    onCustUpdate: CustomerActionCreator.UpdateCustInfo,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    clearError: CustomerActionCreator.CustomerClearError,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    setToyLexLoginSent: FrameworkActionCreator.SetToyLexLogin,
    setLoadingStateToIdle: CustomerActionCreator.SetLoadingStateToIdle,
    gmMemberSearch: CustomerActionCreator.GMMemberSearch,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CustSearch);